module.exports = __webpack_public_path__ + "img/wx_xm_bc@2x.a1876e9b.png";